import type { ComputedRef } from 'vue'
import { computed, useMounted, useNetwork } from '#imports'

export interface UseMediaAutoplayReturn {
    /** Whether decorative background video may download and autoplay. */
    autoplayAllowed: ComputedRef<boolean>
}

/**
 * Central gate for decorative autoplay video (hero backgrounds, game tiles).
 *
 * Blocks when the user sits on a 2g-class connection. The server has no network
 * information, but `useNetwork` reads it synchronously on the client, so the gate
 * only applies once mounted: the hydration render matches the SSR markup and the
 * media is removed right after.
 */
export const useMediaAutoplay = (): UseMediaAutoplayReturn => {
    const { effectiveType } = useNetwork()
    const mounted = useMounted()

    const autoplayAllowed = computed<boolean>(() => {
        if (!mounted.value) return true

        return !(effectiveType.value && ['slow-2g', '2g'].includes(effectiveType.value))
    })

    return { autoplayAllowed }
}
